module.exports = __webpack_public_path__ + "static/homepage_hero1-a607d0e5681c92a28e2c83bb4747e95f.png";